import { render, staticRenderFns } from "./stationMain.vue?vue&type=template&id=cb50afce&scoped=true"
import script from "./stationMain.vue?vue&type=script&lang=js"
export * from "./stationMain.vue?vue&type=script&lang=js"
import style0 from "./stationMain.vue?vue&type=style&index=0&id=cb50afce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb50afce",
  null
  
)

export default component.exports